<!-- 用户协议 -->
<template>
  <div>
    <div class="title">中交智运⽤户服务协议</div>
    <User></User>
  </div>
</template>

<script>
import User from "../components/User.vue";

export default {
  data() {
    return {};
  },

  components: { User },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.title {
  font-size: 16px;
  font-weight: 600;

  margin-bottom: 20px;

  text-align: center;

  color: #000;
}
</style>